/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CaseDocumentView } from './CaseDocumentView';
import type { SimplePatient } from './SimplePatient';
import type { Specimen } from './Specimen';
import type { UserName } from './UserName';

export type CasesWithDocumentView = {
    readonly id?: number;
    /**
     * The Accession Number of the Case
     */
    readonly accession?: string | null;
    /**
     * date/time that we received a WPL order message indicating accessioning was completed
     */
    accession_completed?: string | null;
    active_assignment: UserName;
    readonly case_document_views?: Array<CaseDocumentView>;
    /**
     * Changing this value will NOT modify the collected_date for each specimen.
     */
    collected_date?: string | null;
    readonly created_at?: string;
    finalized_report_id: number;
    finalized_report_s3_location: string;
    max_diagnosis_version: number;
    ordering_doctor: UserName;
    supervising_physician: UserName;
    prelim_report_id: number;
    patient: SimplePatient;
    /**
     * Changing this value will NOT modify the received_date for each specimen.
     */
    received_date?: string | null;
    readonly report_id?: number;
    report_signed: string;
    /**
     * case origin, WPL or PW LIS
     */
    source?: CasesWithDocumentView.source;
    specimens: Array<Specimen>;
    /**
     * True if the patient is paying cash; i.e. no insurance. Aka self-pay
     */
    self_pay?: boolean;
    /**
     * True if the patient is paying cash with an attestation; i.e. no insurance. Aka self-pay with attestation
     */
    self_pay_with_attestation?: boolean;
    /**
     * True if the patient has an indigent pay agreement.
     */
    indigent?: boolean;
}

export namespace CasesWithDocumentView {

    /**
     * case origin, WPL or PW LIS
     */
    export enum source {
        WPL = 'wpl',
        PW = 'pw',
        APL = 'apl',
    }


}
